module.exports = __webpack_public_path__ + "img/alt-max.f4b2fd9f.png";